
import {Component, Prop, Mixins, Watch} from "vue-property-decorator";
import IrtifakVeyaIntifaHakkininKaldirilmasiAlacakKalemiForm
  from "@/components/forms/alacak-kalemi/IrtifakVeyaIntifaHakkininKaldirilmasiAlacakKalemiForm.vue";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import {ItemArrayManagerTableHeader} from "@/interface/TableHeader";
import IlamBilgileriForm from "@/components/forms/alacak/IlamBilgileriForm.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import IrtifakVeyaIntifaHakkininKaldirilmasiAlacakFormWizard
  from "@/components/forms/form-wizard/alacak/IrtifakVeyaIntifaHakkininKaldirilmasiAlacakFormWizard.vue";
import AyEkleForm from "@/components/forms/AyEkleForm.vue";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {TakipAltTipiEntity} from "@/entity/TakipAltTipiEntity";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import {HesapSekli} from "@/enum/HesapSekli";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import {ParaBirimi} from "@/enum/ParaBirimi";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import AsilAlacakKalemiForm from "@/components/forms/alacak-kalemi/AsilAlacakKalemiForm.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import { takipteKdvAlaniniGoster } from "@/helpers/TakipTipiEskiNoHelper";

@Component({
  components: {
    FormDialog, AsilAlacakKalemiForm, DeleteDialog,
    AyEkleForm,
    IrtifakVeyaIntifaHakkininKaldirilmasiAlacakFormWizard,
    IlamBilgileriForm,
    Tutar,
    ItemArrayManager,
    IrtifakVeyaIntifaHakkininKaldirilmasiAlacakKalemiForm,
  },
})
export default class IrtifakVeyaIntifaHakkininKaldirilmasiAlacakForm extends Mixins(ObjectInputMixin) {
  @Prop() takipTipiId!: number;
  @Prop() errorAlacakKalemleri!: boolean;
  @Prop({default:()=>{}}) alacakDetay !: any;
  @Prop({default:()=>[]}) alacakKalemleri!:any
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;
  @Prop({required: false}) takipTipiEskiNo?: string | number;

  get kdvAlaniniGoster(): boolean {
    return takipteKdvAlaniniGoster(this.takipTipiEskiNo);
  }

  isWizardComplete: boolean = false;
  paraBirimi = ParaBirimi;
  alacakKalemiAlani = AlacakKalemiAlani;
  alacakKalemiDetayData:any = {}
  faizTurleri:any[] =  [];
  paraBirimleri:any[] =  []

  async getParaBirimleri(){
    let response = await this.$helper.requestWithCache("/api/v1/para-birimi-picker");
    this.paraBirimleri = response.data;
  }
  async getFaizTurleri(){
    let response = await this.$helper.requestWithCache("/api/v1/faiz-turu/?takibe_ozel_mi=false");
    this.faizTurleri = response.data;
  }

  getTakipOncesiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_oncesi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  getTakipSonrasiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id === item.takip_sonrasi_faiz_turu_id);
    return faizTuruIsim?.isim;
  }
  headers = [
    {text: 'Alacak Kalemi Türü', value: 'alacak_kalemi_alani'},
    {text: 'Açıklama', value: 'aciklama'},
    {text: 'Faiz B. Tarihi', value: 'faiz_baslangic_tarihi'},
    {text: 'Takip Öncesi Faiz', value: 'takip_oncesi_faiz_turu'},
    {text: 'Takip Sonrası Faiz', value: 'takip_sonrasi_faiz_turu'},
    {text: 'Tutar', value: 'tutar'},
    {text: 'İşlemler', value: 'actions'},
  ]

  getParaBirimiSembol(paraBirimiId: number){
    const paraBirimi:any = this.paraBirimleri.find((p:any) => p.id === paraBirimiId);
    return paraBirimi ? paraBirimi.kisa_isim : '';
  }

  onAdd(){
    if (this.localValue.id){
      this.$emit('addAlacakKalemi')
    }
  }

  addAsilAlacak(item:any){
    if(!this.localValue.id){
      this.localValue.asil_alacaklar.push(item)
    }else{
      this.onAdd()
    }
  }

  updateAsilAlacak(updatedItem: any, index: number) {
    if (this.localValue.id) {
      this.$emit('addAlacakKalemi');
    } else {
      this.$set(this.localValue.asil_alacaklar, index, updatedItem);
      this.input();
    }
  }
  alacakKalemiDetay(id:any){
    this.$http.get('/api/v1/alacak-kalemi/' + id).then((response)=>{
      this.alacakKalemiDetayData = response.data;
    })
  }
  deleteAsilAlacak(index: number ){
    if (this.localValue.id){
      this.$emit('delete')
    }else{
      this.localValue.asil_alacaklar.splice(index, 1);
    }
  }

  mounted(){
    this.getFaizTurleri()
    this.getParaBirimleri()
  }

  loadAlacakKalemleri(){
    this.$emit('addAlacakKalemi')

  }
  load() {
    this.$emit('load');
  }
}
